module.exports = __webpack_public_path__ + "img/9.5972f666.png";